var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'detail')?_c('old-html-detail-part',{attrs:{"data":_vm.data}}):(_vm.type === 'picker')?_c('old-html-sku-picker-part',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }